import React from "react";

import styles from "./ToolTip.module.scss";

export interface TooltipProps {
  children: React.ReactNode;
  content: string;
}

const ToolTip = (props: TooltipProps) => {
  return (
    <div className={styles.tooltipContainer} data-tooltip={props.content}>
      {props.children}
    </div>
  );
};

export default ToolTip;
